import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApps, deleteApp } from "../../../store/slices/appSlice";
import { clearError } from "../../../store/slices/broadcastMessageSlice";

export const useApps = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const { apps, loading, error, pagination } = useSelector(
    (state) => state.app
  );
  const filteredApps = apps?.filter((app) =>
    app.station_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const loadApps = useCallback(() => {
    dispatch(fetchApps());
  }, [dispatch]);

  useEffect(() => {
    loadApps();
  }, [loadApps]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(clearError());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  const handleDeleteAppWithConfirmation = (app) => {
    return () => {
      setSelectedApp(app);
      handleDeleteModalToggle();
    };
  };

  const handleDeleteModalToggle = () => {
    setShowDeleteModal((prev) => !prev);
  };

  const handleDeleteApp = useCallback(
    async (appId) => {
      try {
        await dispatch(deleteApp(appId)).unwrap();
        setShowDeleteModal(false);
        loadApps();
        return true;
      } catch (error) {
        return false;
      }
    },
    [dispatch, loadApps]
  );

  return {
    apps,
    loading,
    error,
    pagination,
    showDeleteModal,
    selectedApp,
    searchTerm,
    filteredApps,
    setSearchTerm,
    loadApps,
    handleDeleteApp,
    handleDeleteAppWithConfirmation,
    handleDeleteModalToggle,
    setSelectedApp,
  };
};
